import { axios } from "../../../lib/axios";

export const createUser = async (data: any) => {
  const response = await axios.post(`/user-register`, data);

  return response.data;
};
